export default "/images/b80bb00db96ae33eacf34bbb4f9eab7c.avif";